import React from "react"
import gql from "graphql-tag"
import {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {Query} from "@irati/utils/services/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import userSavings from "../../services/queries/fragments/dealUserSavings"
import boostedSavings from "../../services/queries/fragments/dealBoostedSavings"
import fullDealProductConfig from "../../services/queries/fragments/fullDealProductConfig"

interface Props extends Omit<QueryComponentProps, "query"> {}

const query = gql`
  query HomepageBanners {
    homepageBanners {
      uuid
      offers {
        uuid
        kind
        url
      }
      productConfig {
        ...fullDealProductConfig
      }
      header
      savings {
        ...userSavings
        ...boostedSavings
      }
      urlSlug
      bannerImage
      thumbnailImage
      earnPoints
      type
      tagIds
      provider
    }
  }
  ${userSavings}
  ${boostedSavings}
  ${fullDealProductConfig}
`
const PerksBannerQueryComponent: React.FC<Props> = ({children, ...props}) => {
  return (
    <Query query={query} {...props}>
      {(apolloState: ApolloState) => {
        return children(apolloState)
      }}
    </Query>
  )
}

export default PerksBannerQueryComponent
